// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: 'http://127.0.0.1:8000' | (string & {});
};

export type ArtworkDetail = {
    readonly id: string;
    artwork_type?: ArtworkTypeEnum;
    /**
     * Original image uploaded by the user
     */
    original_image?: string | null;
    thumbnail: string;
    /**
     * This is the state of the frontend image editor. Dimensions and position etc of the cropped image are stored here.
     */
    cropped_image_state?: unknown;
    /**
     * This is the text used for the custom personalized nivea creme logo.
     */
    logo_text?: string;
    readonly created_at: string;
};

/**
 * * `LOGO` - Logo Artwork
 * * `PHOTO` - Photo Artwork
 */
export const ArtworkTypeEnum = { LOGO: 'LOGO', PHOTO: 'PHOTO' } as const;

/**
 * * `LOGO` - Logo Artwork
 * * `PHOTO` - Photo Artwork
 */
export type ArtworkTypeEnum = typeof ArtworkTypeEnum[keyof typeof ArtworkTypeEnum];

/**
 * * `LOGO` - Logo Artwork
 * * `PHOTO` - Photo Artwork
 */
export const AvailableArtworkTypesEnum = { LOGO: 'LOGO', PHOTO: 'PHOTO' } as const;

/**
 * * `LOGO` - Logo Artwork
 * * `PHOTO` - Photo Artwork
 */
export type AvailableArtworkTypesEnum = typeof AvailableArtworkTypesEnum[keyof typeof AvailableArtworkTypesEnum];

export type CreateOrder = {
    readonly id: string;
    readonly squid: string;
    status: StatusEnum;
    readonly created_at: string;
    venue?: string | null;
    positions: Array<RelatedOrderPosition>;
};

export type Decoration = {
    readonly id: string;
    /**
     * The title of the decoration. This is used for display purposes. E.g. 'Christmas Border'
     */
    readonly title: string;
    decoration_type: DecorationTypeEnum;
    /**
     * Text that is added to the artwork.
     */
    readonly text: string;
    thumbnail: string;
};

/**
 * * `TEXT` - Text Decoration
 * * `STICKER` - Sticker Decoration
 * * `FRAME` - Frame Decoration
 */
export const DecorationTypeEnum = {
    TEXT: 'TEXT',
    STICKER: 'STICKER',
    FRAME: 'FRAME'
} as const;

/**
 * * `TEXT` - Text Decoration
 * * `STICKER` - Sticker Decoration
 * * `FRAME` - Frame Decoration
 */
export type DecorationTypeEnum = typeof DecorationTypeEnum[keyof typeof DecorationTypeEnum];

/**
 * Trade a staff user's email + 6-digit code for a JWT access/refresh pair.
 */
export type EmailAndAuthCode = {
    email: string;
    auth_code: string;
};

export type EmailAndAuthToken = {
    email: string;
    auth_token: string;
};

/**
 * Serializer that returns a email token
 */
export type EmailAuth = {
    email: string;
    captcha: string;
    venue?: string;
};

export type EmailLoginResponse = {
    detail: string;
};

/**
 * Serializer for guest user authentication / registration
 */
export type GuestAuth = {
    captcha: string;
};

export type JwtTokenResponse = {
    access: string;
    refresh: string;
};

export type LogoArtworkCreateAndUpdate = {
    readonly id: string;
    logo_text: string;
};

export type MinimalArtworkDetail = {
    readonly id: string;
    thumbnail: string;
    readonly created_at: string;
};

export type MyUser = {
    readonly id: string;
    /**
     * Email address
     */
    readonly email: string;
    /**
     * Active
     *
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    readonly is_active: boolean;
    readonly is_guest: boolean;
};

export type ObtainJwtFromCodeResponse = {
    access: string;
    refresh: string;
};

export type ObtainJwtResponse = {
    access: string;
    refresh: string;
};

export type Order = {
    readonly id: string;
    readonly squid: string;
    status: StatusEnum;
    readonly created_at: string;
    venue: string;
    positions: Array<OrderPosition>;
    /**
     * QRCode using the sqid to link to the order.
     */
    readonly qrcode_image: string | null;
};

export type OrderPosition = {
    artwork: MinimalArtworkDetail;
    quantity?: number;
};

export type PaginatedArtworkDetailList = {
    next?: string | null;
    previous?: string | null;
    results: Array<ArtworkDetail>;
};

export type PaginatedOrderList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Order>;
};

export type PhotoArtworkCreateAndUpdate = {
    readonly id: string;
    original_image?: string;
    cropped_image: string;
    /**
     * This is the state of the frontend image editor. Dimensions and position etc of the cropped image are stored here.
     */
    cropped_image_state?: unknown;
    decorations?: Array<string>;
};

export type RelatedOrderPosition = {
    artwork?: string | null;
    quantity?: number;
};

/**
 * Validate a staff login-code request (email + captcha).
 *
 * The staff-user lookup happens in the view so an unknown / non-staff email
 * still yields a generic success without auto-creating a user.
 */
export type StaffEmailAuth = {
    email: string;
    captcha: string;
};

export type StaffEmailLoginResponse = {
    detail: string;
};

/**
 * * `PENDING` - Pending
 * * `COMPLETED` - Completed
 * * `CANCELLED` - Cancelled
 */
export const StatusEnum = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
} as const;

/**
 * * `PENDING` - Pending
 * * `COMPLETED` - Completed
 * * `CANCELLED` - Cancelled
 */
export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];

export type TokenRefresh = {
    readonly access: string;
    refresh: string;
};

export type TokenVerify = {
    token: string;
};

export type Venue = {
    readonly id: string;
    slug?: string;
    name: string;
    thumbnail: string;
    is_public?: boolean;
    /**
     * Artwork types that can be created and ordered for this venue.
     */
    available_artwork_types?: Array<AvailableArtworkTypesEnum>;
    /**
     * Maximum total quantity across all positions a user can have in a single order for this venue. Leave empty for no limit.
     */
    max_order_quantity?: number | null;
};

export type ArtworkDetailWritable = {
    artwork_type?: ArtworkTypeEnum;
    /**
     * Original image uploaded by the user
     */
    original_image?: string | null;
    thumbnail: string;
    /**
     * This is the state of the frontend image editor. Dimensions and position etc of the cropped image are stored here.
     */
    cropped_image_state?: unknown;
    /**
     * This is the text used for the custom personalized nivea creme logo.
     */
    logo_text?: string;
};

export type CreateOrderWritable = {
    venue?: string | null;
    positions: Array<RelatedOrderPosition>;
};

export type DecorationWritable = {
    thumbnail: string;
};

export type LogoArtworkCreateAndUpdateWritable = {
    logo_text: string;
};

export type MinimalArtworkDetailWritable = {
    thumbnail: string;
};

export type OrderWritable = {
    venue: string;
    positions: Array<OrderPositionWritable>;
};

export type OrderPositionWritable = {
    artwork: MinimalArtworkDetailWritable;
    quantity?: number;
};

export type PaginatedArtworkDetailListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<ArtworkDetailWritable>;
};

export type PaginatedOrderListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<OrderWritable>;
};

export type PhotoArtworkCreateAndUpdateWritable = {
    original_image?: string;
    cropped_image: string;
    /**
     * This is the state of the frontend image editor. Dimensions and position etc of the cropped image are stored here.
     */
    cropped_image_state?: unknown;
    decorations?: Array<string>;
};

export type TokenRefreshWritable = {
    refresh: string;
};

export type VenueWritable = {
    slug?: string;
    name: string;
    thumbnail: string;
    is_public?: boolean;
    /**
     * Artwork types that can be created and ordered for this venue.
     */
    available_artwork_types?: Array<AvailableArtworkTypesEnum>;
    /**
     * Maximum total quantity across all positions a user can have in a single order for this venue. Leave empty for no limit.
     */
    max_order_quantity?: number | null;
};

export type AccountsDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this user.
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/accounts/{id}/';
};

export type AccountsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AccountsDestroyResponse = AccountsDestroyResponses[keyof AccountsDestroyResponses];

export type ArtworksListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/api/v1/artworks/';
};

export type ArtworksListResponses = {
    200: PaginatedArtworkDetailList;
};

export type ArtworksListResponse = ArtworksListResponses[keyof ArtworksListResponses];

export type ArtworksDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this artwork.
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/artworks/{id}/';
};

export type ArtworksDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ArtworksDestroyResponse = ArtworksDestroyResponses[keyof ArtworksDestroyResponses];

export type ArtworksRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this artwork.
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/artworks/{id}/';
};

export type ArtworksRetrieveResponses = {
    200: ArtworkDetail;
};

export type ArtworksRetrieveResponse = ArtworksRetrieveResponses[keyof ArtworksRetrieveResponses];

export type ArtworksPrintTemplateRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this artwork.
         */
        id: string;
    };
    query?: {
        /**
         * Number of identical pages to render. Defaults to 1.
         */
        copies?: number;
        /**
         * Print layout key (e.g. 'a6_landscape'). Defaults to A6 landscape.
         */
        layout?: string;
    };
    url: '/api/v1/artworks/{id}/print-template/';
};

export type ArtworksPrintTemplateRetrieveErrors = {
    /**
     * No response body
     */
    400: unknown;
    /**
     * No response body
     */
    404: unknown;
};

export type ArtworksPrintTemplateRetrieveResponses = {
    200: Blob | File;
};

export type ArtworksPrintTemplateRetrieveResponse = ArtworksPrintTemplateRetrieveResponses[keyof ArtworksPrintTemplateRetrieveResponses];

export type ArtworksCreateLogoArtworkCreateData = {
    body: LogoArtworkCreateAndUpdateWritable;
    path?: never;
    query?: never;
    url: '/api/v1/artworks/create-logo-artwork/';
};

export type ArtworksCreateLogoArtworkCreateResponses = {
    201: ArtworkDetail;
};

export type ArtworksCreateLogoArtworkCreateResponse = ArtworksCreateLogoArtworkCreateResponses[keyof ArtworksCreateLogoArtworkCreateResponses];

export type ArtworksCreatePhotoArtworkCreateData = {
    body: PhotoArtworkCreateAndUpdateWritable;
    path?: never;
    query?: never;
    url: '/api/v1/artworks/create-photo-artwork/';
};

export type ArtworksCreatePhotoArtworkCreateResponses = {
    201: ArtworkDetail;
};

export type ArtworksCreatePhotoArtworkCreateResponse = ArtworksCreatePhotoArtworkCreateResponses[keyof ArtworksCreatePhotoArtworkCreateResponses];

export type AuthRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this user.
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/auth/{id}/';
};

export type AuthRetrieveResponses = {
    200: MyUser;
};

export type AuthRetrieveResponse = AuthRetrieveResponses[keyof AuthRetrieveResponses];

export type AuthEmailLoginCreateData = {
    body: EmailAuth;
    path?: never;
    query?: never;
    url: '/api/v1/auth/email_login/';
};

export type AuthEmailLoginCreateResponses = {
    200: EmailLoginResponse;
};

export type AuthEmailLoginCreateResponse = AuthEmailLoginCreateResponses[keyof AuthEmailLoginCreateResponses];

export type AuthGuestLoginCreateData = {
    body: GuestAuth;
    path?: never;
    query?: never;
    url: '/api/v1/auth/guest_login/';
};

export type AuthGuestLoginCreateResponses = {
    200: JwtTokenResponse;
};

export type AuthGuestLoginCreateResponse = AuthGuestLoginCreateResponses[keyof AuthGuestLoginCreateResponses];

export type AuthObtainJwtFromEmailCodeCreateData = {
    body: EmailAndAuthCode;
    path?: never;
    query?: never;
    url: '/api/v1/auth/obtain_jwt_from_email_code/';
};

export type AuthObtainJwtFromEmailCodeCreateResponses = {
    200: ObtainJwtFromCodeResponse;
};

export type AuthObtainJwtFromEmailCodeCreateResponse = AuthObtainJwtFromEmailCodeCreateResponses[keyof AuthObtainJwtFromEmailCodeCreateResponses];

export type AuthObtainJwtFromEmailTokenCreateData = {
    body: EmailAndAuthToken;
    path?: never;
    query?: never;
    url: '/api/v1/auth/obtain_jwt_from_email_token/';
};

export type AuthObtainJwtFromEmailTokenCreateResponses = {
    200: ObtainJwtResponse;
};

export type AuthObtainJwtFromEmailTokenCreateResponse = AuthObtainJwtFromEmailTokenCreateResponses[keyof AuthObtainJwtFromEmailTokenCreateResponses];

export type AuthStaffEmailLoginCreateData = {
    body: StaffEmailAuth;
    path?: never;
    query?: never;
    url: '/api/v1/auth/staff_email_login/';
};

export type AuthStaffEmailLoginCreateResponses = {
    200: StaffEmailLoginResponse;
};

export type AuthStaffEmailLoginCreateResponse = AuthStaffEmailLoginCreateResponses[keyof AuthStaffEmailLoginCreateResponses];

export type AuthTokenRefreshCreateData = {
    body: TokenRefreshWritable;
    path?: never;
    query?: never;
    url: '/api/v1/auth/token/refresh/';
};

export type AuthTokenRefreshCreateResponses = {
    200: TokenRefresh;
};

export type AuthTokenRefreshCreateResponse = AuthTokenRefreshCreateResponses[keyof AuthTokenRefreshCreateResponses];

export type AuthTokenVerifyCreateData = {
    body: TokenVerify;
    path?: never;
    query?: never;
    url: '/api/v1/auth/token/verify/';
};

export type AuthTokenVerifyCreateResponses = {
    200: TokenVerify;
};

export type AuthTokenVerifyCreateResponse = AuthTokenVerifyCreateResponses[keyof AuthTokenVerifyCreateResponses];

export type OrdersListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * A search term.
         */
        search?: string;
        /**
         * * `PENDING` - Pending
         * * `COMPLETED` - Completed
         * * `CANCELLED` - Cancelled
         */
        status?: Array<'CANCELLED' | 'COMPLETED' | 'PENDING'>;
    };
    url: '/api/v1/orders/';
};

export type OrdersListResponses = {
    200: PaginatedOrderList;
};

export type OrdersListResponse = OrdersListResponses[keyof OrdersListResponses];

export type OrdersCreateData = {
    body: CreateOrderWritable;
    path?: never;
    query?: never;
    url: '/api/v1/orders/';
};

export type OrdersCreateResponses = {
    201: CreateOrder;
};

export type OrdersCreateResponse = OrdersCreateResponses[keyof OrdersCreateResponses];

export type OrdersRetrieveData = {
    body?: never;
    path: {
        identifier: string;
    };
    query?: never;
    url: '/api/v1/orders/{identifier}/';
};

export type OrdersRetrieveResponses = {
    200: Order;
};

export type OrdersRetrieveResponse = OrdersRetrieveResponses[keyof OrdersRetrieveResponses];

export type OrdersCancelCreateData = {
    body?: never;
    path: {
        identifier: string;
    };
    query?: never;
    url: '/api/v1/orders/{identifier}/cancel/';
};

export type OrdersCancelCreateErrors = {
    /**
     * No response body
     */
    400: unknown;
};

export type OrdersCancelCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type OrdersCompleteCreateData = {
    body?: never;
    path: {
        identifier: string;
    };
    query?: never;
    url: '/api/v1/orders/{identifier}/complete/';
};

export type OrdersCompleteCreateErrors = {
    /**
     * No response body
     */
    400: unknown;
    /**
     * No response body
     */
    403: unknown;
};

export type OrdersCompleteCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type OrdersPrintTemplateRetrieveData = {
    body?: never;
    path: {
        identifier: string;
    };
    query?: {
        /**
         * Print layout key (e.g. 'a6_landscape'). Defaults to A6 landscape.
         */
        layout?: string;
    };
    url: '/api/v1/orders/{identifier}/print-template/';
};

export type OrdersPrintTemplateRetrieveErrors = {
    /**
     * No response body
     */
    400: unknown;
    /**
     * No response body
     */
    404: unknown;
};

export type OrdersPrintTemplateRetrieveResponses = {
    200: Blob | File;
};

export type OrdersPrintTemplateRetrieveResponse = OrdersPrintTemplateRetrieveResponses[keyof OrdersPrintTemplateRetrieveResponses];

export type SseRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/sse/';
};

export type SseRetrieveResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type SseRetrieve2Data = {
    body?: never;
    path: {
        channel: string;
    };
    query?: never;
    url: '/api/v1/sse/{channel}/';
};

export type SseRetrieve2Responses = {
    /**
     * No response body
     */
    200: unknown;
};

export type VenuesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/api/v1/venues/';
};

export type VenuesListResponses = {
    200: Array<Venue>;
};

export type VenuesListResponse = VenuesListResponses[keyof VenuesListResponses];

export type VenuesRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID or slug of the venue.
         */
        identifier: string;
    };
    query?: never;
    url: '/api/v1/venues/{identifier}/';
};

export type VenuesRetrieveResponses = {
    200: Venue;
};

export type VenuesRetrieveResponse = VenuesRetrieveResponses[keyof VenuesRetrieveResponses];

export type VenuesDecorationsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID or slug of the venue.
         */
        identifier: string;
    };
    query?: never;
    url: '/api/v1/venues/{identifier}/decorations/';
};

export type VenuesDecorationsRetrieveResponses = {
    200: Decoration;
};

export type VenuesDecorationsRetrieveResponse = VenuesDecorationsRetrieveResponses[keyof VenuesDecorationsRetrieveResponses];
